export default __webpack_public_path__ + "static/media/2560px-Cassandra_logo.svg.874f9f56.png";